module.exports = __webpack_public_path__ + "static/media/footer-contact.80908c67.png";